<template>
  <div>
    <div class="ir-sub-menu">
      <ul class="col3">
        <li>
          <a href="/ir/stock">株式情報</a>
        </li>
        <li>
          <a href="/ir/securities" class="selected">株主総会</a>
        </li>
        <li>
          <a href="/ir/stock_quotations">株価情報</a>
        </li>
      </ul>
    </div>
    <section>
      <div class="l-service">
        <div class="l-service-header">
          <h2 class="heading-default heading-default-center">株主総会</h2>
          <h3 class="heading-small heading-small-center heading-small-mt-sp">
            SHAREHOLDERS MEETING
          </h3>

          <div class="l-service-content-inner">
            <!-- E-IR Parts -->
            <div id="eirArea"></div>
            <div id="doEirWrapper"></div>
            <!-- /E-IR Parts -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "株主総会",
      titleTemplate: "株主総会 | 株式について | IR情報 | 株式会社 旅工房",
    };
  },
  mounted: function () {
    let doEirWrapper = document.getElementById("doEirWrapper");
    let doEirScript = document.createElement("script");
    doEirScript.innerHTML = 'setParts("meeting")';
    doEirWrapper.appendChild(doEirScript);
  },
};
</script>
